import { render } from "./AdministrationView.vue?vue&type=template&id=75a71adf"
import script from "./AdministrationView.vue?vue&type=script&lang=js"
export * from "./AdministrationView.vue?vue&type=script&lang=js"

import "./AdministrationView.vue?vue&type=style&index=0&id=75a71adf&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__